// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"14":"1297c950","19":"4003eb79","30":"ff21553f","63":"51c88bd6","71":"87cf344d","239":"d1b9b32a","316":"72d53615","436":"8bde7b03","455":"7358b7f4","895":"eca0346d"}[chunkId] + ".chunk.js";
};